// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import Racking from '../../../../components/gudang_old/bahan-baku/racking';
import StockGudang from '../../../../components/gudang_old/bahan-baku/stock-gudang';
import UsageStock from '../../../../components/gudang_old/bahan-baku/usage-stock';
import OpnameStock from '../../../../components/gudang_old/bahan-baku/opname-stock';
import DetailMutasi from '../../../../components/gudang_old/bahan-baku/detail-mutasi';
import ProgressPembelian from '../../../../components/gudang_old/bahan-baku/progress-pembelian';
import PR from '../../../../components/gudang_old/bahan-baku/purchase-request';
import TransferStock from '../../../../components/gudang_old/bahan-baku/transfer-stock';
import GoodsReceipt from '../../../../components/gudang_old/bahan-baku/goods-receipt';

import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useSearchParams, useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 0,
    bottom: 8,
    width: 100,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 200,
        position: 'static'
    }
}))

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const navigate = useNavigate();
    // Ambil value tab dari query param
    const [searchParams] = useSearchParams();
    const currentTab = searchParams.get('tab') || 'default';

    // ** State
    const [value, setValue] = useState<string>(currentTab)

    const handleChangeTab = (event: SyntheticEvent, newValue: string) => {
        navigate(`?tab=${newValue}`);
        setValue(newValue)
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title={'GUDANG BAHAN BAKU'} />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={value}>
                        <TabList
                            scrollButtons
                            variant='fullWidth'
                            onChange={handleChangeTab}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='1' label='RACKING' icon={<Icon icon='mdi:office-building-marker' />} />
                            <Tab value='2' label='STOCK GUDANG' icon={<Icon icon='mdi:warehouse' />} />
                            <Tab value='3' label='USAGE STOCK' icon={<Icon icon='mdi:file-document-arrow-right-outline' />} />
                            <Tab value='4' label='OPNAME STOCK' icon={<Icon icon='mdi:clipboard-list-outline' />} />
                            <Tab value='5' label='DETAIL MUTASI' icon={<Icon icon='mdi:folder-arrow-left-right-outline' />} />
                            <Tab value='6' label='PROGRESS PEMBELIAN' icon={<Icon icon='mdi:cart-variant' />} />
                            <Tab value='7' label='PURCHASE REQUEST' icon={<Icon icon='mdi:package-check' />} />
                            <Tab value='8' label='TRANSFER STOCK' icon={<Icon icon='mdi:warehouse' />} />
                            <Tab value='9' label='GOOD RECEIPT' icon={<Icon icon='mdi:truck' />} />
                        </TabList>
                        <TabPanel value='1'>
                            <Racking />
                        </TabPanel>
                        <TabPanel value='2'>
                            <StockGudang />
                        </TabPanel>
                        <TabPanel value='3'>
                            <UsageStock />
                        </TabPanel>
                        <TabPanel value='4'>
                            <OpnameStock />
                        </TabPanel>
                        <TabPanel value='5'>
                            <DetailMutasi />
                        </TabPanel>
                        <TabPanel value='6'>
                            <ProgressPembelian />
                        </TabPanel>
                        <TabPanel value='7'>
                            <PR />
                        </TabPanel>
                        <TabPanel value='8'>
                            <TransferStock />
                        </TabPanel>
                        <TabPanel value='9'>
                            <GoodsReceipt />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
